import { serializable, alias, primitive } from 'serializr';

export class ActivityData {
  @serializable
  id?: number;

  @serializable(alias('activity_label', primitive()))
  activityLabel?: string;
}
